import { BodyTextRegularB } from '@/shared/ui/typography2';
import { useScopedI18n } from '@locales/client';
import styled from 'styled-components';
import { Button } from '@radix-ui/themes';

export const PaymentPartners = ({ openWalletManagment }) => {
  const t = useScopedI18n('common.footer');

  const icons: string[] = [
    'visa',
    'mastercard',
    'gpay',
    'apay',
    'bitcoin',
    'skrill',
    // 'qiwi',
    'hamster-silver',
    'etherium',
    'stripe',
    'paypal',
  ];

  return (
    <BlockWrapper>
      <TitleContainer>
        <BodyTextRegularB color="#AFAFAF">
          {t('payment_partners_title').toUpperCase()}
        </BodyTextRegularB>
        <Line />
      </TitleContainer>
      <Content>
        {icons.map((icon, index) => (
          <PayButton key={index} onClick={openWalletManagment}>
            <ImageContainer
              src={`/images/icons/footer/pm-${icon}-bw.svg`}
              $hoverSrc={`/images/icons/footer/pm-${icon}.svg`}
            />
          </PayButton>
        ))}
      </Content>
    </BlockWrapper>
  );
};

const BlockWrapper = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 12px;
`;
const TitleContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  align-self: stretch;
`;
const Line = styled.div`
  display: flex;
  flex: 1 0 0;
  height: 1px;
  background-color: #565656;
`;
const Content = styled.div`
  display: flex;
  justify-content: space-between;
  overflow-x: auto;
`;
const PayButton = styled(Button)`
  width: 80px;
  height: 55px;
  cursor: pointer;
`;
export const ImageContainer = styled.div<{
  src: string;
  $hoverSrc: string;
}>`
  width: 80px;
  height: 55px;
  background-image: url(${(props) => props.src});
  background-size: cover;
  transition: background-image 0.3s ease;

  @media screen and (min-width: 841px) {
    &:hover {
      background-image: url(${(props) => props.$hoverSrc});
    }
  }
`;
